import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type PartnerUserRow = {
  id: string;
  partner_id: string;
  user_id: string | null;
  name: string;
  email: string;
  role_at_partner: string | null;
  is_primary: boolean;
  created_at: string;
};

// GET /api/partners/:id/users — partner-detail People tab roster.
export function usePartnerUsers(partnerId: string | undefined) {
  return useQuery<PartnerUserRow[], ApiClientError>({
    queryKey: queryKeys.partners.users(partnerId ?? ""),
    queryFn: () => apiFetch<PartnerUserRow[]>(`/partners/${partnerId}/users`),
    enabled: !!partnerId,
  });
}
